import { render, staticRenderFns } from "./metodo-de-pago.vue?vue&type=template&id=cf3dd3c4&"
import script from "./metodo-de-pago.vue?vue&type=script&lang=js&"
export * from "./metodo-de-pago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports